export default __webpack_public_path__ + "static/media/GSP1.4c150ce6.png";